'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  display: flex;\n  justify-content: center;\n'], ['\n  width: 100%;\n  display: flex;\n  justify-content: center;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  padding: 0px 8px;\n  font-size: 1em;\n  margin: 2px 5px;\n  font-weight: 500;\n  color: ', '\n  cursor: pointer;\n\n  &:hover {\n    color: ', ';\n  }\n'], ['\n  padding: 0px 8px;\n  font-size: 1em;\n  margin: 2px 5px;\n  font-weight: 500;\n  color: ', '\n  cursor: pointer;\n\n  &:hover {\n    color: ', ';\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _color = require('../color');

var _color2 = _interopRequireDefault(_color);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); } // there are 10 page links shown at any time (e.g. 1 2 3 4 5 6 7 8 9 10) unless there are less than 10 total pages
// the active link (current page) is in the 6th position, except for when the active link is below 6 or less than 4 from the last position

var PageContainer = _styledComponents2.default.div(_templateObject);

var PageItem = _styledComponents2.default.div(_templateObject2, _color2.default.grey_main, _color2.default.purple_main);

var selectedStyle = {
  border: '2px solid ' + _color2.default.blue_accent,
  borderRadius: '5px',
  color: _color2.default.blue_accent
};

var MozartPagination = function (_Component) {
  _inherits(MozartPagination, _Component);

  function MozartPagination(props) {
    _classCallCheck(this, MozartPagination);

    var _this = _possibleConstructorReturn(this, (MozartPagination.__proto__ || Object.getPrototypeOf(MozartPagination)).call(this, props));

    _this.state = {
      current: _this.getInitialPage(props),
      data: []
    };
    return _this;
  }

  _createClass(MozartPagination, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.renderPagination();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (this.props.pageCount !== nextProps.pageCount || this.props.initialPage !== nextProps.initialPage) {
        this.setState({
          current: this.getInitialPage(nextProps)
        }, function () {
          _this2.renderPagination();
        });
      }
    }
  }, {
    key: 'getInitialPage',
    value: function getInitialPage(props) {
      var initialPage = props.initialPage;
      return initialPage < 1 ? 1 : initialPage;
    }
  }, {
    key: 'getItem',
    value: function getItem(current) {
      var style = current === this.state.current ? selectedStyle : {};
      return _react2.default.createElement(
        PageItem,
        { style: style, onClick: this.handleClick.bind(this, current) },
        current
      );
    }
  }, {
    key: 'getLeftItem',
    value: function getLeftItem() {
      var current = this.state.current;

      var DATA = [];
      var count = current - 5 <= 0 ? 1 : current - 5;
      while (count < current) {
        DATA.push(this.getItem(count));
        count++;
      }
      DATA.push(this.getItem(current));
      return DATA;
    }
  }, {
    key: 'getRightItem',
    value: function getRightItem() {
      var current = this.state.current;
      var pageCount = this.props.pageCount;

      var DATA = [];
      if (current + 5 < pageCount) {
        DATA.push(this.getItem(pageCount));
        if (current + 6 !== pageCount) {
          DATA.push('...');
        }
      }
      var count = current + 5 > pageCount ? pageCount : current + 5;
      while (count > current) {
        DATA.push(this.getItem(count));
        count--;
      }
      return DATA.reverse();
    }
  }, {
    key: 'handleClick',
    value: function handleClick(count) {
      var _this3 = this;

      this.setState({ current: count }, function () {
        _this3.renderPagination();
        if (_this3.props.onPageChange) {
          _this3.props.onPageChange(count);
        }
      });
    }
  }, {
    key: 'renderPagination',
    value: function renderPagination() {
      var leftItems = this.getLeftItem();
      var rightItems = this.getRightItem();
      this.setState({ data: leftItems.concat(rightItems) });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          style = _props.style,
          themeId = _props.themeId;

      return _react2.default.createElement(
        PageContainer,
        { 'data-qa': this.props.testId, style: style, 'data-theme': themeId },
        this.state.data
      );
    }
  }]);

  return MozartPagination;
}(_react.Component);

MozartPagination.propTypes = {
  /** qa attribute */
  testId: _propTypes2.default.string,
  /** theme attribute */
  themeId: _propTypes2.default.string,
  /** initial page selected */
  initialPage: _propTypes2.default.number,
  /** total page */
  pageCount: _propTypes2.default.number,
  /** on page change */
  onPageChange: _propTypes2.default.func
};
MozartPagination.defaultProps = {
  initialPage: 1,
  testId: 'MozartPagination',
  themeId: 'MozartPagination'
};
exports.default = MozartPagination;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Mozart/MozartPagination/MozartPagination.js
// module id = 778
// module chunks = 1